module.exports = __webpack_public_path__ + "static/media/tape.584fff7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/tape.svg
// module id = 30
// module chunks = 1